import type { ColDef } from 'ag-grid-community';

export const rateColumnDefinitions: ColDef[] = [
  {
    field: 'name',
    type: 'string',
  },
  {
    field: 'currency',
    type: 'currency',
  },
];
